<template>
  <div class="mock-captcha">
    <div class="mock-captcha-box" :class="{ 'verified': isVerified }">
      <div v-if="!isVerified" class="mock-captcha-content" @click="handleVerify">
        <div class="checkbox">
          <span v-if="isLoading" class="spinner"></span>
          <span v-else class="checkmark"></span>
        </div>
        <span class="text">Sou humano (Mock para DEV)</span>
      </div>
      <div v-else class="mock-captcha-verified">
        <div class="verified-icon">✓</div>
        <span class="verified-text">Verificado (Mock)</span>
        <button class="reset-button" @click="handleReset">Resetar</button>
      </div>
    </div>
    <div class="mock-captcha-footer">
      <span class="brand">mock reCAPTCHA</span>
      <span class="dev-mode">Modo DEV</span>
    </div>
  </div>
</template>

<script>
/**
 * MockCaptcha Component
 * 
 * This component simulates the Google reCAPTCHA interface for development purposes.
 * It implements the same API as vue-recaptcha for seamless development/production switching.
 */
export default {
  name: 'MockCaptcha',
  
  props: {
    sitekey: {
      type: String,
      default: 'mock-dev-sitekey'
    },
    loadRecaptchaScript: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      isVerified: false,
      isLoading: false
    };
  },
  
  methods: {
    /**
     * Handles verification click and emits the verify event
     */
    handleVerify() {
      this.isLoading = true;
      
      // Simulate a short delay for UX purposes
      setTimeout(() => {
        this.isLoading = false;
        this.isVerified = true;
        
        // Generate a mock response token
        const mockToken = `mock_token_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
        
        // Emit verification event with mock token
        this.$emit('verify', mockToken);
        
        console.log('[DEV] MockCaptcha verification successful', mockToken);
      }, 800);
    },
    
    /**
     * Resets the captcha state
     */
    handleReset() {
      this.isVerified = false;
      this.$emit('expired');
      console.log('[DEV] MockCaptcha reset');
    },
    
    /**
     * Public method to reset the captcha
     * This matches the vue-recaptcha API
     */
    reset() {
      this.handleReset();
    },
    
    /**
     * Public method to execute the captcha programmatically
     * This matches the vue-recaptcha API
     */
    execute() {
      this.handleVerify();
    }
  },
  
  mounted() {
    console.log('[DEV] MockCaptcha mounted - reCAPTCHA mocked for development');
  }
};
</script>

<style scoped>
.mock-captcha {
  width: 304px;
  height: 78px;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  margin-top: 20px;
}

.mock-captcha-box {
  height: 74px;
  border-radius: 3px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mock-captcha-content {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.checkbox {
  width: 24px;
  height: 24px;
  border-radius: 2px;
  border: 2px solid #c1c1c1;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.checkmark {
  width: 5px;
  height: 12px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-top: -4px;
  opacity: 0;
}

.text {
  margin-left: 12px;
  color: #555;
  font-size: 14px;
}

.mock-captcha-verified {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.verified {
  background-color: #f0fff0;
  border-color: #0ca00c;
}

.verified-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #0ca00c;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.verified-text {
  margin-left: 12px;
  color: #0ca00c;
  font-size: 14px;
  font-weight: 500;
}

.reset-button {
  margin-left: 12px;
  padding: 4px 8px;
  font-size: 12px;
  background-color: #f2f2f2;
  border: 1px solid #d3d3d3;
  border-radius: 3px;
  cursor: pointer;
}

.reset-button:hover {
  background-color: #e6e6e6;
}

.mock-captcha-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  height: 18px;
}

.brand {
  font-size: 10px;
  color: #888;
}

.dev-mode {
  font-size: 10px;
  color: #ff6600;
  font-weight: bold;
  text-transform: uppercase;
}
</style> 